import React from "react";

import "./Backdrop.styles.scss";

const Backdrop = (props) => <div className="backdrop" onClick={props.click} />;

export default Backdrop;
